import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Client } from 'app/models/client.models';

@Injectable({ providedIn: 'root' })
export class ClientService {
  constructor(private http: HttpClient) {}

  getProveedores(): Observable<Client[]> {
    return this.http.get<Client[]>(`${environment.apiUrl}client/type/proveedor`);
  }
}
